import { LOCALES } from "./locales";

export const messages = {
    [LOCALES.GERMAN]: {
        Anschlussprofil:"Anschlussprofil",
        Anstroemgeschwindigkeit:"Anströmgeschwindigkeit",
        Anstroemkalotten_einseitig_V_Form:"Anströmkalotten einseitig V-Form",
        Berechnung_Kulissen:"Berechnung Kulissen",
        Berechnung_Schalldaempfer:"Berechnung Schalldämpfer",
        Bestellschluessel:"Bestellschlüssel",
        Breite:"Breite",
        Daempfungswerte_auf_Anfrage:"Dämpfungswerte auf Anfrage",
        Datum: 'Datum',
        Druckbereich:"Druckbereich",
        Druckverlust:"Druckverlust",
        Einfuegungsdaempfung:"Einfügungsdämpfung",
        Eingabe:"Eingabe",
        Eingabe_Kulissen:"Eingabe Kulissen",
        Eingabedaten:"Eingabedaten",
        Fuehrungsschienen:"Führungsschienen",
        Fuehrungsschienen_im_Kanal:"Führungsschienen im Kanal (für Kulissen lose und revisionierbar)",
        Gewicht:"Gewicht",
        HKL_Kulisse_mit_Lochblech:"HKL Kulisse mit Lochblech",
        HKR_Kulisse_mit_Resonanzblech:"HKR Kulisse mit Resonanzblech",
        HKRL_Kulisse_Resonanz_und_Lochblech:"HKRL Kulisse Resonanz- und Lochblech",
        HKS_Kulisse_Standard:"HKS Kulisse Standard",
        Hoehe:"Höhe",
        Kanalbreite:"Kanalbreite",
        Kanalhoehe:"Kanalhöhe",
        Kanallaenge:"Kanallänge",
        Kulisse:"Kulisse",
        Kulissen_in_Folie:"Kulissen in Folie",
        Kulissen_in_Folie_fetthaltige_Luft:"Kulissen in Folie (für fetthaltige Luft)",
        Kulissen_Seite:"Kulissen Seite",
        Kulissenanzahl:"Kulissenanzahl",
        Kulissenbreite:"Kulissenbreite",
        Kulissendaten:"Kulissendaten",
        Kulissengewicht:"Kulissengewicht",
        Kulissenhoehe:"Kulissenhöhe",
        Kulissenlaenge:"Kulissenlänge",
        Kulissenspalt:"Kulissenspalt",
        Kulissentyp:"Kulissentyp",
        Laenge:"Länge",
        LwA:"LwA",
        Link_kopieren:"Link kopieren",
        Link_kopiert:"Link kopiert!",
        PDF_Dokument:"PDF Dokument",
        Datenblatt:"PDF Datenblatt",
        PDF_Dateiname:"Dateiname PDF Datenblatt",
        Fehlerhafter_Dateiname:"Fehlerhafter Dateiname",
        Preis:"Preis",
        Preis_mit_Rabatt: "Preis inkl. {n, number}% Rabatt",
        Preis_auf_Anfrage:"Preis auf Anfrage",
        Rabatt:"Rabatt",
        Schalldaempfer:"Schalldämpfer",
        Schalldaempfer_Seite:"Schalldämpfer Seite",
        Schalldaempferdaten:"Schalldämpferdaten",
        Spaltgeschwindigkeit:"Spaltgeschwindigkeit",
        Volumenstrom:"Volumenstrom",
        Zusatzoptionen:"Zusatzoptionen",
        zzglMwst:"zzgl. Mwst.",
    },
    [LOCALES.ENGLISH]: {
        Anschlussprofil:"Flange profile",
        Anstroemgeschwindigkeit:"Air flow velocity",
        Anstroemkalotten_einseitig_V_Form:"Front profile in V shape on one side",
        Berechnung_Kulissen:"Calculation Baffles",
        Berechnung_Schalldaempfer:"Calculation Silencer",
        Bestellschluessel:"Item code",
        Breite:"Width",
        Daempfungswerte_auf_Anfrage:"Attenuation values on request",
        Datum: 'Date',
        Druckbereich:"Pressure class",
        Druckverlust:"Pressure drop",
        Einfuegungsdaempfung:"Insertion attenuation",
        Eingabe:"Data Entry",
        Eingabe_Kulissen:"Data Entry Baffles",
        Eingabedaten:"Entry data",
        Fuehrungsschienen:"Slides in casing for loose or removable baffles",
        Fuehrungsschienen_im_Kanal:"Slides in casing for loose or removable baffles",
        Gewicht:"Weight",
        HKL_Kulisse_mit_Lochblech:"HKL Baffle expanded metal",
        HKR_Kulisse_mit_Resonanzblech:"HKR Baffle resonance plate",
        HKRL_Kulisse_Resonanz_und_Lochblech:"HKRL expanded metal & resonance plate",
        HKS_Kulisse_Standard:"HKS Baffle standard",
        Hoehe:"Height",
        Kanalbreite:"Casing width",
        Kanalhoehe:"Casing height",
        Kanallaenge:"Casing length",
        Kulisse:"Baffle",
        Kulissen_in_Folie:"Baffles wrapped in plastic film (kitchen exhaust)",
        Kulissen_in_Folie_fetthaltige_Luft:"Baffles wrapped in plastic film (kitchen exhaust)",
        Kulissen_Seite:"Baffles Page",
        Kulissenanzahl:"Number of baffles",
        Kulissenbreite:"Baffle width",
        Kulissendaten:"Baffle Data",
        Kulissengewicht:"Baffle weight",
        Kulissenhoehe:"Baffle height",
        Kulissenlaenge:"Baffle length",
        Kulissenspalt:"Baffle spacing",
        Kulissentyp:"Baffle type",
        Laenge:"Length",
        LwA:"Sound power level",
        Link_kopieren:"Copy link",
        Link_kopiert:"Link copied!",
        PDF_Dokument:"PDF Document",
        Datenblatt:"PDF datasheet",
        PDF_Dateiname:"PDF datasheet file name",
        Fehlerhafter_Dateiname:"Invalid file name",
        Preis:"Price",
        Preis_mit_Rabatt: "Price incl. {n, number}% discount",
        Preis_auf_Anfrage:"Price on request",
        Rabatt:"Discount",
        Schalldaempfer:"Silencer results",
        Schalldaempfer_Seite:"Silencer page",
        Schalldaempferdaten:"Silencer data",
        Spaltgeschwindigkeit:"Spacing velocity",
        Volumenstrom:"Volume flow",
        Zusatzoptionen:"Additional options",
        zzglMwst:"plus VAT",
    },
    [LOCALES.FRENCH]: {
        Anschlussprofil:"Profile de bride",
        Anstroemgeschwindigkeit:"Vitesse d'air",
        Anstroemkalotten_einseitig_V_Form:"Profil de face en forme de V sur un côté",
        Berechnung_Kulissen:"Calcul des Baffles",
        Berechnung_Schalldaempfer:"Calcul des Silencieux",
        Bestellschluessel:"Code article",
        Breite:"Largeur",
        Daempfungswerte_auf_Anfrage:"Valeur d'attenuation sur demande",
        Datum: 'Date',
        Druckbereich:"Classe de pression",
        Druckverlust:"Perte de charge",
        Einfuegungsdaempfung:"Perte d'insertion",
        Eingabe:"Donnée d'entrée",
        Eingabe_Kulissen:"Donnée d'entrée",
        Eingabedaten:"Données entrée",
        Fuehrungsschienen:"Glissières  pour baffles séparées ou amovibles",
        Fuehrungsschienen_im_Kanal:"Glissières  pour baffles séparées ou amovibles",
        Gewicht:"Poids",
        HKL_Kulisse_mit_Lochblech:"HKL Baffle plaque de protection",
        HKR_Kulisse_mit_Resonanzblech:"HKR baffle à résonance",
        HKRL_Kulisse_Resonanz_und_Lochblech:"HKRL baffle métal déployé",
        HKS_Kulisse_Standard:"HKS baffle standard",
        Hoehe:"Hauteur",
        Kanalbreite:"Profondeur Caisson",
        Kanalhoehe:"Hauteur Caisson",
        Kanallaenge:"Longueur Caisson",
        Kulisse:"Baffle",
        Kulissen_in_Folie:"Baffles enveloppées dans un film plastique (extraction cuisine)",
        Kulissen_in_Folie_fetthaltige_Luft:"Baffles enveloppées dans un film plastique (extraction cuisine)",
        Kulissen_Seite:"Baffle page",
        Kulissenanzahl:"Nombre de baffle",
        Kulissenbreite:"Profondeur baffle",
        Kulissendaten:"Données de la baffle",
        Kulissengewicht:"Poids de la baffle",
        Kulissenhoehe:"Hauteur baffle",
        Kulissenlaenge:"Longueur de baffle",
        Kulissenspalt:"Espace entre Baffles",
        Kulissentyp:"Type de baffle",
        Laenge:"Longueur",
        LwA:"Puissance sonore",
        Link_kopieren:"Copier le lien",
        Link_kopiert:"Lien copié !",
        PDF_Dokument:"PDF Document",
        Datenblatt:"Fiche technique PDF",
        PDF_Dateiname:"Nom du fichier de la fiche technique PDF",
        Fehlerhafter_Dateiname:"Nom de fichier invalide",
        Preis:"Prix",
        Preis_mit_Rabatt: "Prix incluant une remise de {n, number}%",
        Preis_auf_Anfrage:"Prix sur demande",
        Rabatt:"Remise",
        Schalldaempfer:"Resultast silencieux",
        Schalldaempfer_Seite:"Silencieux",
        Schalldaempferdaten:"Données du silencieux",
        Spaltgeschwindigkeit:"Vitesse de passage",
        Volumenstrom:"Débit d'air",
        Zusatzoptionen:"Autres options",
        zzglMwst:"plus TVA",
    },

};